import React, { useState, useEffect, useRef } from "react";
import { withSnackbar } from "notistack";
import { Grid, Table, TableBody, Paper, Dialog } from "@material-ui/core";
import { ModsTaskForm, ModsList } from "../components";
import { fillModsEditFormApi } from "../apiServices";
import ModsHd from "../components/ModsHd";
import BasicDetailHeader from "../../BasicDetailHeader";
import { assetFilterOps } from "./ModsTableHead";
import { EmptyCollection, PageLoader, AccessDenied, DeletePopUp } from "../../../../shared_elements";
import { convertFilterObject, removeEmptyKey, permissionCheckFnforCamo, downloadFileType, checkApiStatus } from "../../../../utils";
import { globalGetService, globalDeleteService, globalExportService, globalFileUploadService, globalPutService } from "../../../../utils/globalApiServices";
import { trackActivity } from '../../../../utils/mixpanel';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import moment from "moment";
import Pagination from "../../../../shared_elements/components/Pagination";
import ImportFileModule from "../../../../shared_elements/components/import_Format/ImportFileModule";
import SubDetails from "../../../../shared_elements/components/sub_details/SubDetails"
import CtaAction from "../../../../shared_elements/components/cta/CtaAction";
const MOD = (props) => {
	const { enqueueSnackbar, match, aircraftTypes, engineTypes, lessees } = props;

	const [pageLoader, setPageLoader] = useState(false);
	const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
	const [filter, setFilter] = useState({});
	const [assetsDetail, setAssetsDetail] = useState({
		list: [],
		pagination: {},
		new_task_last_used_folder_uuid: '',
		last_used_folder_uuid_link_document: '',
		checkbox_last_used_folder_uuid: '',
		checkbox_last_used_folder_name: ''
	});
	const [modsCRU, setModsCRU] = useState({ modal: false, data: null, id: null, attachments: null, item: null, mode: '' });
	const [deleteModal, setDeleteModal] = useState({ modal: false, data: null });
	const [importFiles, setImportFiles] = useState({ modal: false });
	const [slug, setSlug] = useState("");
	const [headerTsn, setHeaderTsn] = useState("");
	const [headerCsn, setHeaderCsn] = useState("");
	const [uuid, setUuid] = useState("");
	const [isBasicDetailExpanded, setIsBasicDetailExpanded] = useState(true);
	const [basicDetails, setBasicDetails] = useState({});

	const tabIndex = 0;
	const timeoutRef = useRef(null);
	const currentRecordPerPageRef = useRef(250);

	const getModsData = (queryParams = {}, searchString = null) => {
		if (!permissionCheckFnforCamo({ primaryKey: "mod_status", keyIndex: "R" })) return;
		setPageLoader(true);
		clearTimeout(timeoutRef.current);
		timeoutRef.current = setTimeout(() => {
			const { asset, assetType: assetTypeParam } = match.params;
			globalGetService('camo/mods/list/', {
				...queryParams,
				per_page: queryParams.per_page || currentRecordPerPageRef.current,
				asset,
				asset_type: assetTypeParam,
				search: searchString,
			}).then((response) => {
				if (checkApiStatus(response)) {
				const cleanFilter = { ...queryParams };
				delete cleanFilter.page;
				delete cleanFilter.per_page;
				delete cleanFilter.asset_type;
				delete cleanFilter.sort;
				delete cleanFilter.sort_by;
				setFilter(cleanFilter);
				setPageLoader(false);
				setAssetsDetail(prev => ({
					...prev,
					list: response.data.results,
					pagination: {
						...prev.pagination,
						total: response.data.pagination.total,
						per_page: response.data.pagination.per_page,
						page: parseInt(response.data.pagination.current_page),
					},
					new_task_last_used_folder_uuid: response.data.new_task_last_used_folder_uuid,
					last_used_folder_uuid_link_document: response.data.last_used_folder_uuid_link_document,
					checkbox_last_used_folder_uuid: response.data.checkbox_last_used_folder_uuid,
					checkbox_last_used_folder_name: response.data.checkbox_last_used_folder_name,
				}));
				} else {
					enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
					setPageLoader(false);
				}
			});

		}, 500);
	};

	useEffect(() => {
		getModsData({ per_page: currentRecordPerPageRef.current });
		trackActivity('CAMO', {
			event_type: 'Page Visited',
			page_title: 'Modifications(MODs)',
		});
	}, []);

	const pullData = (slugVal, tsn, csn) => {
		setSlug(slugVal);
		setHeaderTsn(tsn);
		setHeaderCsn(csn);
	};

	const uuidData = (uuidVal) => {
		setUuid(uuidVal);
	};

	const deleteModsRecord = () => {
		const item = deleteModal.data;
		globalDeleteService(`camo/mods/${item.id}/delete/`).then((response) => {
			setDeleteModal({ modal: false, data: null });
			if (response.status === 200) {
				enqueueSnackbar("Record Deleted Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
				trackActivity('CAMO', { event_type: 'Item Deleted', page_title: 'Asset Detail Row', item_id: item.id || '' });
			}
			if (response.status === 500) {
				enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
			}
			getModsData({ per_page: currentRecordPerPageRef.current });
		});
	};

	const handleEditMod = (e,item) => {
		fillModsEditFormApi(item, props).then((response) => {
			const data = response.data.data;
			setModsCRU({ modal: true, data, id: data.id, attachments: data.attachments, item, mode: 'edit' });
		});
	};

	const createSortHandler = (sortField) => {
		const newSortBy = sortField === sortInfo.sort ? (sortInfo.sort_by === "asc" ? "desc" : "asc") : "asc";
		const newSortInfo = { sort: sortField, sort_by: newSortBy };
		setSortInfo(newSortInfo);
		getModsData({
			...filter,
			...newSortInfo,
			per_page: assetsDetail.pagination.per_page,
			asset_type: tabIndex,
		});
	};

	const updateFormData = (updateId, updatedData) => {
		if (!permissionCheckFnforCamo({ primaryKey: "mod_status", keyIndex: "U" })) return;
		setPageLoader(true);
		globalPutService(`camo/mods/${updateId}/update/`, updatedData).then((response) => {
			if (response.status === 500) {
				enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
			} else {
				setPageLoader(false);
				enqueueSnackbar("Record Updated Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
				getModsData({ per_page: currentRecordPerPageRef.current });
			}
		});
	};

	const fileUploadData = (_uploadId, formdata, _prps, haveAttachments) => {
		setPageLoader(true);
		if (haveAttachments) {
			globalFileUploadService('camo/attachment/upload/', formdata).then((response) => {
				if (response.status === 500) {
					enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				} else {
					setPageLoader(false);
					getModsData({ per_page: currentRecordPerPageRef.current });
				}
			}).catch((err) => { console.error(err); });
		} else {
			enqueueSnackbar("Data Submitted Successfully", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
			setPageLoader(false);
			getModsData({ per_page: currentRecordPerPageRef.current });
		}
	};

	const exportAssetDetailList = (extension) => {
		setPageLoader(true);
		const todayDate = moment(new Date()).format("YYYY-MM-DD");
		const { asset, assetType: assetTypeParam } = match.params;
		const exportParams = { ...convertFilterObject(removeEmptyKey(filter), filterOptions) };
		delete exportParams.asset_type;
		globalExportService(`/camo/mods/${asset}/${assetTypeParam}/export/`, { download: extension, ...exportParams })
			.then((response) => {
				setPageLoader(false);
				if (checkApiStatus(response)) {
					downloadFileType(response.data, `${todayDate}_ESN ${basicDetails?.esn || basicDetails?.msn}_Mods`, extension);
					enqueueSnackbar("Download of MOD List successful", { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
					trackActivity("CAMO", { event_type: "Item Exported", page_title: "Asset Listing", extension });
				} else {
					enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
				}
			});
	};

	const downloadSampleFile = (extension) => {
		setPageLoader(true);
		globalExportService('camo/mods/sample-file/').then((response) => {
			setPageLoader(false);
			if (checkApiStatus(response)) {
				downloadFileType(response.data, 'SampleFile_MOD', extension);
				trackActivity("CAMO", { event_type: 'Sample File Downloaded', page_title: "Mods", extension });
			} else {
				enqueueSnackbar("Something went wrong.", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
			}
		});
	};

	const downloadAllFiles = async (item) => {
		setPageLoader(true);
		const attachment_list = item.download_attachments.map(entry => [entry[0], decodeURIComponent(entry[1])]);
		const zip = new JSZip();
		const folder = zip.folder('DownloadedFiles');
		try {
			const downloadPromises = attachment_list.map(async (entry) => {
				const res = await fetch(entry[1] || '');
				if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
				const blob = await res.blob();
				folder.file(entry[0], blob);
			});
			await Promise.all(downloadPromises);
			const content = await zip.generateAsync({ type: 'blob' });
			saveAs(content, 'MODS.zip');
			setPageLoader(false);
		} catch (error) {
			console.error('Error:', error);
			setPageLoader(false);
		}
	};

	const refreshComp = () => {
		getModsData({ per_page: currentRecordPerPageRef.current });
	};

	let filterOptions = { ...assetFilterOps };
	if (tabIndex === 0 || tabIndex === 1) {
		filterOptions = { ...filterOptions, aircraft_type: { ...filterOptions.aircraft_type, options: aircraftTypes } };
		if (tabIndex === 1) delete filterOptions.engine_type;
	}
	if (tabIndex === 0 || tabIndex === 2) {
		filterOptions = { ...filterOptions, engine_type: { ...filterOptions.engine_type, options: engineTypes } };
		if (tabIndex === 2) delete filterOptions.aircraft_type;
	}
	filterOptions = { ...filterOptions, lessee: { ...filterOptions.lessee, options: lessees } };

	return (
		<section className="amp-listing-section">
			{pageLoader ? <PageLoader /> : null}
			<Grid style={{ marginTop: 0 }} spacing={3} container>
				<Grid style={{ paddingTop: 0, paddingRight: 0 }} xs={12} item>
					<SubDetails
						masterExport={false}
						title="Modifications"
						slug={slug}
						match={match}
						onRefresh={() => getModsData({ per_page: 250 })}
						permissionCheck={permissionCheckFnforCamo({ primaryKey: "mod_status", keyIndex: "U" })}
					/>
					<BasicDetailHeader props={props} func={pullData} uuid={uuidData} module='mods' engineType={(data) => setBasicDetails(data)} onAccordionChange={setIsBasicDetailExpanded} />
					{permissionCheckFnforCamo({ primaryKey: "mod_status", keyIndex: "R" }) ? (
						<Paper square style={{ padding: "5px", marginTop: "10px" }} variant="outlined">
							<CtaAction
								searchPlaceholder="Search ATA Chapter, MOD Reference Number, Description"
								onSearch={(value) => getModsData({ per_page: currentRecordPerPageRef.current }, value)}
								permissionCheck={!permissionCheckFnforCamo({ primaryKey: "mod_status", keyIndex: "C" }) || window?.location?.search.includes('archived-assets')}
								addLabel="ADD MODIFICATION"
								onAddFn={() => setModsCRU({ modal: true, data: null, mode: 'add' })}
								onImportFn={() => setImportFiles({ modal: true })}
								exportMenu={{
									exportReportFn: (file) => exportAssetDetailList(file?.extension),
									files: [{ title: 'EXCEL', extension: 'xlsx' }, { title: 'PDF', extension: 'pdf' }],
									disabled: !assetsDetail?.list?.length,
								}}
								downloadSampleMenu={{
									exportReportFn: (file) => downloadSampleFile(file?.extension),
									files: [{ title: 'DOWNLOAD SAMPLE', extension: 'xlsx', type: 'sample' }],
								}}
							/>
							<div style={{ height: `${window.innerHeight - (isBasicDetailExpanded ? 430 : 295)}px`, overflow: 'auto' }}>
								<Table className="mui-table-format" stickyHeader>
									<ModsHd
										sort={sortInfo.sort}
										sort_by={sortInfo.sort_by}
										createSortHandler={createSortHandler}
									/>
									<TableBody>
										{assetsDetail.list.map((item, index) => (
											<ModsList
												key={index}
												item={item}
												index={index}
												uuid={uuid}
												assetsDetail={assetsDetail}
												getResponseBack={refreshComp}
												last_used_folder_uuid={assetsDetail.new_task_last_used_folder_uuid}
												last_used_folder_uuid_link_document={assetsDetail.last_used_folder_uuid_link_document}
												checkbox_last_used_folder_uuid={assetsDetail.checkbox_last_used_folder_uuid}
												checkbox_last_used_folder_name={assetsDetail.checkbox_last_used_folder_name}
												headerTsn={headerTsn}
												headerCsn={headerCsn}
												toggleDelteModalFn={() => setDeleteModal({ modal: true, data: item })}
												toggleEditModalFn={handleEditMod}
												updateFormData={updateFormData}
												props={props}
												fileUploadData={fileUploadData}
												downloadAllApi={() => downloadAllFiles(item)}
												currentRecordPerPage={currentRecordPerPageRef.current}
											/>
										))}
									</TableBody>
								</Table>
								{!assetsDetail.list.length ? <EmptyCollection title="No Records Found" /> : null}
							</div>
							<Pagination
								pagination={assetsDetail.pagination}
								onChangeRowsPerPage={(event) => {
									currentRecordPerPageRef.current = event.target.value;
									getModsData({ page: 1, per_page: event.target.value });
								}}
								onChangePage={(_event, newPage) => getModsData({
									...convertFilterObject(removeEmptyKey({ ...filter, asset_type: tabIndex }), filterOptions),
									per_page: assetsDetail.pagination.per_page,
									page: newPage + 1,
								})}
							/>
						</Paper>
					) : (
						<AccessDenied />
					)}
				</Grid>
			</Grid>

			{modsCRU?.modal ? (
				<Dialog open={true} maxWidth="lg" fullWidth>
					<ModsTaskForm
						formTitle={modsCRU.mode === 'edit' ? "Update Modifications" : "Modifications"}
						closeAddForm={() => setModsCRU({ modal: false, data: null, id: null, attachments: null, item: null, mode: '' })}
						props={props}
						actionType={modsCRU.mode}
						editFormId={modsCRU.id}
						editFormData={modsCRU.data}
						attachments={modsCRU.attachments}
						item={modsCRU.item}
						headerTsn={headerTsn}
						headerCsn={headerCsn}
						updateFormData={updateFormData}
						fileUploadData={fileUploadData}
						currentRecordPerPage={currentRecordPerPageRef.current}
						uuid={uuid}
						getResponseBack={refreshComp}
						last_used_folder_uuid={assetsDetail.new_task_last_used_folder_uuid}
						last_used_folder_uuid_link_document={assetsDetail.last_used_folder_uuid_link_document}
						checkbox_last_used_folder_uuid={assetsDetail.checkbox_last_used_folder_uuid}
						checkbox_last_used_folder_name={assetsDetail.checkbox_last_used_folder_name}
					/>
				</Dialog>
			) : null}

			{deleteModal?.modal ? (
				<DeletePopUp
					title="Delete MOD Record"
					deleteRecordFn={deleteModsRecord}
					modal={true}
					content="Do you really want to delete this record?"
					toggleModalFn={() => setDeleteModal({ modal: false, data: null })}
				/>
			) : null}

			{importFiles?.modal ? (
				<ImportFileModule
					importUrl={`camo/mods/${match?.params?.asset}/${match?.params?.assetType}/import/`}
					title="Import Modifications"
					getResponseBack={refreshComp}
					toggleModalFn={() => setImportFiles({ modal: false })}
				/>
			) : null}
		</section>
	);
};

export default withSnackbar(MOD);
